import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToastFooterProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function ToastFooter({ className, children, ...props }: ToastFooterProps) {
  return (
    <div
      className={twMerge(
        'text-foreground-placeholder flex w-full flex-row items-center gap-1.5 text-xs [&>span]:min-w-0 [&>span]:flex-1',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
